import { Flux } from 'flummox';
import PlaylistStore from './stores/PlaylistStore';
import PlaylistActions from './actions/PlaylistActions';

class AppFlux extends Flux {
  constructor() {
    super();

    this.createActions('playlist', PlaylistActions);
    this.createStore('playlist', PlaylistStore, this);
  }
}

export default new AppFlux();


/** WEBPACK FOOTER **
 ** ./src/flux.jsx
 **/